import React, { useEffect, useState, useMemo } from 'react';
import COOKIES from '../../../../config/cookies/cookies';
import {
  DEAL_EXPRESS_CHECKOUT_LOGGED_IN,
  DEAL_EXPRESS_CHECKOUT_LOGGED_OUT,
} from '../../../../config/text/text';
import { setCookie } from '../../../../helpers/cookieSetter';

const ExpressCheckoutText = ({
  isAuthenticated = false,
  margin = '0',
  paddingTop = '0',
  shouldRenderComplianceText = false,
}) => {
  const [emailOptOut, setEmailOptOut] = useState(false);

  useEffect(() => {
    const emailToggle = document.querySelector('#emailToggle2');

    if (!emailToggle) return;

    const handler = () => {
      setEmailOptOut((previous) => {
        const newOptOutState = !previous;
        setCookie({ key: COOKIES.emailOptOut, value: newOptOutState });

        return newOptOutState;
      });
    };

    emailToggle.addEventListener('click', handler);

    return () => emailToggle.removeEventListener('click', handler);
  });

  const complianceText = useMemo(() => {
    if (!shouldRenderComplianceText) return null;

    return isAuthenticated
      ? DEAL_EXPRESS_CHECKOUT_LOGGED_IN
      : DEAL_EXPRESS_CHECKOUT_LOGGED_OUT(emailOptOut ? "- I'M OUT!" : '');
  }, [isAuthenticated, emailOptOut, shouldRenderComplianceText]);

  if (!shouldRenderComplianceText) return null;

  return (
    <p
      className="express-checkout-text"
      dangerouslySetInnerHTML={{ __html: complianceText }}
      style={{
        backgroundColor: 'white',
        fontSize: '9px',
        margin,
      }}
    />
  );
};

export default React.memo(ExpressCheckoutText);
